import { HeaderText } from "@src/components/general/HeaderText";
import {
  Flexbox,
  HorizontalFlexbox,
  VerticalFlexbox,
} from "@src/components/layout/Flexbox";
import { ClipboardList } from "lucide-react";
import { DocumentUpload, useNewOpportunityIds } from "./DocumentUpload";
import { HealthConcerns } from "./HealthConcerns";
import { Snapshot } from "./Snapshot";

export const BriefingPage = () => {
  const { newIds, markAsNew } = useNewOpportunityIds();

  return (
    <VerticalFlexbox gap="sm" className="w-full px-4 py-4 md:px-8 md:py-6">
      <HorizontalFlexbox
        alignItems="center"
        justifyContent="space-between"
        gap="sm"
      >
        <HorizontalFlexbox alignItems="center" gap="xs">
          <Flexbox
            alignItems="center"
            justifyContent="center"
            className="size-8 rounded-lg bg-accent/10 text-accent"
          >
            <ClipboardList className="size-4" />
          </Flexbox>
          <HeaderText tag="h2" fontWeight={600} className="text-lg">
            Clinical Briefing
          </HeaderText>
        </HorizontalFlexbox>
        <DocumentUpload onNewOpportunities={markAsNew} />
      </HorizontalFlexbox>
      <VerticalFlexbox gap="sm">
        <Snapshot />
        <HealthConcerns newOpportunityIds={newIds} />
      </VerticalFlexbox>
    </VerticalFlexbox>
  );
};
